/* eslint-disable */
import React, { useEffect, useState } from 'react';
import RevenueByRegion from './RevenueByRegion/revenueByRegion';
import RevenueByOfferings from './RevenueByOfferings/revenueByOfferings';
import styles from './revenue.module.scss';
import { FormControl, Autocomplete, TextField } from '@mui/material';
import totalProjectionImage from '../../../Assets/images/svg/dar_total_projection.svg';
import confirmedRealizationImage from '../../../Assets/images/svg/dar_confirmed_realization.svg';
import pendingContactsImage from '../../../Assets/images/svg/dar_pending_contacts.svg';
import workProgressImage from '../../../Assets/images/svg/dar_work_progress.svg';
import lostImage from '../../../Assets/images/svg/dar_lost.svg';
import dealConversionImage from '../../../Assets/images/svg/dar_deal_conversion.svg';
import TableView from './TableView/tableView';

const Revenue = () => {
  const [dropdowns, setDropdowns] = useState([
    {
      id: 1,
      label: 'Select vertical',
      selectedValue: '',
      options: [
        { value: 'App Mod', label: 'App Mod' },
        { value: 'Infra Mod', label: 'Infra Mod' },
        { value: 'Data Mod', label: 'Data Mod' }
      ],
    },
    {
      id: 2,
      label: 'Select financial year',
      selectedValue: '',
      options: [
        { value: 2021, label: 'FY 2021' },
        { value: 2022, label: 'FY 2022' },
        { value: 2023, label: 'FY 2023' }
      ]
    },
    {
      id: 3,
      label: 'Select quarter',
      selectedValue: '',
      options: [
        { value: 1, label: 'Q1' },
        { value: 2, label: 'Q2' },
        { value: 3, label: 'Q3' }
      ]
    }
  ]);
  const analysisBox = [
    {
      id: 1,
      heading: 'Total projection',
      image: totalProjectionImage,
      value: '$50K'
    },
    {
      id: 2,
      heading: 'Confirmed realization',
      image: confirmedRealizationImage,
      value: '$20K (40%)'
    },
    {
      id: 3,
      heading: 'Pending contract closure',
      image: pendingContactsImage,
      value: '$10K (20%)'
    },
    {
      id: 4,
      heading: 'Work in progress',
      image: workProgressImage,
      value: '$20K (40%)'
    },
    {
      id: 5,
      heading: 'Lost',
      image: lostImage,
      value: '$10K (20%)'
    },
    {
      id: 6,
      heading: 'Deal conversion rate',
      image: dealConversionImage,
      value: '30%'
    }
  ];
  
  useEffect(() => {
    window.scrollTo(0, 0);
    handleSubmit();
  }, []);

  const getSelectedValueById = (id) => {
    const dropdown = dropdowns.find((d) => d.id === id);
    return dropdown ? dropdown.selectedValue : null;
  };

  const handleSubmit = () => { // code to fetch selectedValue from the dropdowns.
    const selectedVertical = getSelectedValueById(1);
    const selectedYear = getSelectedValueById(2);
    const selectedQuarter = getSelectedValueById(3);
  };

  const handleChange = (event, id) => {
    const newValue = event.target.value;
    setDropdowns((prevDropdowns) =>
      prevDropdowns.map((dropdown) =>
        dropdown.id === id
          ? { ...dropdown, selectedValue: newValue } // Update the selected value of the changed dropdown
          : dropdown
      )
    );
  };

  return (
    <div className={styles['revenue-container']}>
      <div className={styles['revenue-header-text']}>Revenue projections</div>
      <div className={styles['revenue-header-background']}>
        <div className={styles['revenue-section-main']}>
        <div className={styles['revenue-section-heading']}>Analytics</div>
        <div className={styles['revenue-section-inputs-main']}>
            {dropdowns.map((dropdown) => (
        <FormControl
        key={dropdown.id}
        variant="standard"
        className={`${styles['revenue-section-form-control']} ${styles['revenue-section-form-mr12']}`}
      >
        <Autocomplete
          value={dropdown.selectedValue || ''} // Fallback to empty string if null
          onChange={(event, newValue) => {
            handleChange({ target: { value: newValue || '' } }, dropdown.id);  // Set to empty string if cleared
          }}
          options={dropdown.options.map((option) => option.label)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              placeholder={dropdown.label}
              sx={{
                width: 210, // Fixed width for input box
                fontSize: 14,
              }}
            />
          )}
          sx={{
            '& .MuiAutocomplete-paper': {
              minWidth: '200px', // Ensure the dropdown has a minimum width
              maxWidth: 'auto',  // Let it grow based on content
            },
          }}
        />
      </FormControl>            
            ))}
        </div>
        </div>
        <div>
          <div className={styles['revenue-gridContainer']}>
            {analysisBox.map((item) => (
              <div key={item.id} className={styles['revenue-grid-box']}>
                <div className={styles['revenue-gridContainer-projection']}>{item.heading}</div>
                <div className={styles['revenue-gridContainer-projection-valueMain']}>
                  <img className={styles['revenue-gridContainer-projection-img']} src={item.image} alt="images" />
                  <div className={styles['revenue-totalProjection-text']}>{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles['revenue-projection-main']}>
        <div className={styles['revenue-projection-offerings-main']}><RevenueByOfferings selectedValues={dropdowns}/></div>
          <div className={styles['revenue-projection-region-main']}><RevenueByRegion /></div>
        </div>
      </div>
      <TableView />
    </div>
  );
};

export default Revenue;
